import { Component, OnInit } from '@angular/core';
import { SubcategoryService } from '../../shared/subcategory.service';
import { AngularFirestore } from '@angular/fire/firestore';
import { ToastrService } from 'ngx-toastr';
import { Subcategory } from '../../shared/subcategory.model';
import { Observable } from 'rxjs';
import { Category } from '../../shared/category.model';
import { CategoryService } from '../../shared/category.service';
import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';

@Component({
  selector: 'app-subcategory-list',
  templateUrl: './subcategory-list.component.html',
  styleUrls: ['./subcategory-list.component.css']
})
export class SubcategoryListComponent implements OnInit {

  subcategory: Subcategory[];
  category: Category[];

  constructor(
    private service:SubcategoryService,
    private serviceCategory:CategoryService,
    private firestore:AngularFirestore,
    private toastr : ToastrService) { }

  ngOnInit() {
    this.service.getSubcategory().subscribe(actionArray =>{
      this.subcategory = actionArray.map(item => {
        const data = item.payload.doc.data() as Subcategory;
        const id = item.payload.doc.id;

        //const category = item.payload.doc.data().category;
        return { id, ...data };
      })
    });


    
  }

  
  onEdit(subcat:Subcategory){
    this.service.subcategoryData = Object.assign({},subcat);
  }

  onDelete(id: string){
    if(confirm("Are you sure to delete this Sub Category?")){
      this.firestore.doc('subCategory/' +id).delete();
      this.toastr.warning('Deleted Successfuly','Sub Category');
    }
  }

}
